import { makeStyles } from '@material-ui/core/styles';
import { seriousGameShellStyles } from '../shell.styles';

export const useSeriousGameViewStyles = makeStyles(() => ({
  ...seriousGameShellStyles,
  cardInner: {
    ...seriousGameShellStyles.cardInner,
    alignItems: 'center',
  },
  coverBlock: {
    width: '95%',
    display: 'flex',
    justifyContent: 'center',
  },
}));
